import { createContext } from 'react';

import type { BreakpointState } from './breakpoints';

/** Gevuld door de `BreakpointProvider`; leeg wanneer die ontbreekt. */
export const BreakpointContext = createContext<BreakpointState | null>(null);
